export default __webpack_public_path__ + "static/media/plus-grey.46422cde.svg";